export default __webpack_public_path__ + "static/media/Kaizen.00d3e29b.png";